export default __webpack_public_path__ + "static/media/underline.3141067c.svg";